module.exports = __webpack_public_path__ + "img/rimg3.135cc83d.png";